<template>
  <div>
    <title-edit header="Member Information" />
    <line-hr />
    <div class="row">
      <v-col cols="4" sm="3"  xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="6" sm="8"  xs="12" style="text-align: right">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Branch :</label>
      </v-col>
      <v-col cols="6" sm="8"  xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Topic :</label>
      </v-col>
      <v-col cols="6" sm="8"  xs="12">
        <select-option :items="optionTopic" :model="form.member_topic_type_id" @update="updateTopic" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Member name TH* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title_th" @update="updateMemberNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Member name EN* :</label>
      </v-col>
      <v-col cols="6" sm="8"  xs="12">
        <input-text-field :model="form.title_en" @update="updateMemberNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="6" sm="8"  xs="12">
        <input-editor :model="form.detail_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-editor :model="form.detail_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  xs="12" class="label">
        <label>Slug Url :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.slug_url" @update="updateSlugURL" />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteMembers" @save-info="saveMembers" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import SwitchSelect from "../../../components/Input/StyleUtility";
import { mapState } from "vuex";
import SelectOption from "../../../components/Input/selectOption";
import {permissionMembershipMember, role} from "../../../util/Permission";
import Swal from 'sweetalert';
import CommandButton from "../../../components/Layout/CommandButton";
export default {
  name: "MemberEdit",
  data() {
    return {
      permission : null,
      optionBranch: [],
      optionTopic: [],
      title: "Membership",
      save_id: null
    };
  },
  components: {
    CommandButton,
    SelectOption,
    SwitchSelect,
    InputEditor,
    InputTextField,
    SaveButton,
    PreviewButton,
    DeleteButton,
    LineHr,
    TitleEdit
  },
  computed: {
    permissionMembershipMember,
    ...mapState({
      form: state => {
        return state.Members.form;
      }
    })
  },
  created() {
    this.permission = role;
    this.getBranchData();
    this.getMemberTopicData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    getMemberTopicData() {
      this.$store.dispatch("Members/getMemberTopicData").then(res => {
        this.optionTopic = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.id,
            text: type.name_th + " (" + type.name_en + ")"
          }))
        ];
      });
    },
    validateSave() {
      // if (!this.form.branch_id) {
      // Swal('','Please select Branch !','error');
      //   return false;
      // } else
      if (!this.form.title_th) {
        Swal('','Please insert Title TH !','error');
        return false;
      } else if (!this.form.title_en) {
        Swal('','Please insert Title EN !','error');
        return false;
      } else if (!this.form.detail_th) {
        Swal('','Please insert Description TH !','error');
        return false;
      } else if (!this.form.detail_en) {
        Swal('','Please insert Description EN !','error');
        return false;
      } else {
        return true;
      }
    },
    saveClose() {
      if (this.validateSave()) {
        this.$store
                .dispatch("Members/saveMembers", {
                  id: this.save_id ? this.save_id : this.form.id,
                  data: this.form
                })
                .then(res => {
                  Swal(res.response_msg);
                  if (res.response_code === 200) {
                    this.goToMembersTable();
                  }
                });
      }
    },
    saveMembers() {
      if (this.validateSave()) {
        this.$store
          .dispatch("Members/saveMembers", {
            id: this.save_id ? this.save_id : this.form.id,
            data: this.form
          })
          .then(res => {
            this.save_id = res.result.id;
            Swal(res.response_msg);
          });
      }
    },
    deleteMembers() {
      this.$store
        .dispatch("Members/deleteMembers", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code === 200) {
            this.goToMembersTable();
          }
        })
        .catch(() => {
          Swal('','Delete members failed!','error');
        });
    },
    goToMembersTable() {
      this.$router.push("/membership/members");
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateTopic(val) {
      this.form.member_topic_type_id = val;
    },
    updateMemberNameTH(val) {
      this.form.title_th = val;
    },
    updateMemberNameEN(val) {
      this.form.title_en = val;
    },
    updateDescriptionTH(val) {
      this.form.detail_th = val;
    },
    updateDescriptionEN(val) {
      this.form.detail_en = val;
    },
    updateSlugURL(val) {
      this.form.slug_url = val;
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/switch.css";
</style>
